<template>
    <div>
        <button class="btn btn-light float-left" @click="navigatePrevious" v-show="!isFirst()">Voltar</button>
        <button class="btn btn-primary float-right" v-if="!loadingBtn" @click="navigateNext">{{ nextButtonText() }}</button>
        <button class="btn btn-primary float-right" type="button" v-if="loadingBtn" disabled>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Loading...
        </button>
        <!--{{ proposal }}-->
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { required, email } from 'vuelidate/lib/validators'

import axios from 'axios';

var bootstrap = require('bootstrap');
var bootbox = require('bootbox');

export default {
    data() {
        return {
            loadingBtn: false,
        }
    },
    props: ["stepOneValidations", "stepTwoValidations", "isInvalid", "isInvalid2", "goNext"],
    computed: {
        ...mapState(['user', 'proposal'])
    },
    mutations: {
        ...mapMutations(['setProposal'])
    },
    methods: {
        ...mapMutations(['setParticipantArray']),
        ...mapActions(['createProposal']),
        nextButtonText(){
            if (
                this.$route.name === 'documentations'
                || (this.$route.name === 'documentations' && !this.$store.state.hasFourthStep)
            ) {
                return 'Enviar';
            }
            return 'Avançar'
        },
        
        isFirst(){
            return this.$route.name === 'participants'
        },
        
        async navigateNext(){
            if (this.$route.name === 'participants'){
                console.log('Primeira validação!')
                this.stepOneValidations()
                if (this.isInvalid ||  !this.goNext) {
                    console.log('Está dando erro');
                } else {
                    this.$router.push('/proposalInformations');
                }
            } else if (this.$route.name === 'proposalInformations'){
                console.log('Segunda validação!')
                this.stepTwoValidations()
                if (this.isInvalid2) {
                    console.log('Está dando erro');
                } else {
                    this.$router.push('/documentations');

                    bootbox.alert({
                    message: "A agilidade de todo o seu processo depende da qualidade dos documentos enviados! Por favor, certifique-se que a documentação está completa, dentro do prazo e legível",
                    centerVertical: true,
                    locale: 'pt',
                    buttons: {
                         ok: {
                            label: "Entendi!",
                        }
                    }

                    });
                }
                
            } else {

                this.loadingBtn = true
                const res = await this.createProposal(this.$store.state.proposal)
                if(res){
                    this.setParticipantArray([])
                }
                this.loadingBtn = false 
                //alert(`${this.$store.state.proposal.cpf}`)

            }
        },

        navigatePrevious(){
             if (this.$route.name === 'documentations'){
                this.$router.push('/proposalInformations');
            } else if (this.$route.name === 'proposalInformations'){
                this.$router.push('/participants');
            }
        }
    }    
}
</script>
<style scoped>
.modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }
 
    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }
 
    .modal-container {
        width: 70%;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }
 
    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }
 
    .modal-body {
        margin: 20px 0;
    }
 
    .modal-default-button {
        float: right;
    }
 
    .modal-enter {
        opacity: 0;
    }
 
    .modal-leave-active {
        opacity: 0;
    }
 
    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
    .btn {
    font-size: 11px;
    padding: 8px 26px 6px;
    letter-spacing: 1.7px;
    text-transform: uppercase;
    border-radius: 2px;
    outline: none;
    -webkit-transition: 0.15s linear;
    transition: 0.15s linear;
    }
    .btn-primary {
      color: #fff;
      background-color: #50a1ff;
      border-color: #50a1ff;
    }
</style>